import clsx from 'clsx';
import './RibbonItem.css';

const RibbonItem = ({ icon, number, description }) => {
  return (
    <div className="ribbon-item">
        <img className="ribbon-icon" src={icon} alt={description} />
        <div className={clsx("impact-info", !number && "no-number")}>
            {number ? <div className="impact-number">{number}</div> : null}
            <div className="impact-description">{description}</div>
        </div>
    </div>
  );
}

export default RibbonItem;